'use client';

import { type ReactNode } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

/**
 * Scoped MUI date-pickers `LocalizationProvider`. Mounted only by layouts or
 * components that render date pickers, so the `@mui/x-date-pickers` +
 * `date-fns` graphs (~170 KB gzip) stay off routes without date fields.
 */
export function DateLocalizationProvider({
  children,
}: {
  children: ReactNode;
}) {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      {children}
    </LocalizationProvider>
  );
}
